import React from 'react';
import { Link } from 'react-router-dom';
import { Telescope } from 'lucide-react';

interface FeatureUnavailableProps {
  title?: string;
  message?: string;
}

export const FeatureUnavailable: React.FC<FeatureUnavailableProps> = ({
  title = 'Página não encontrada — em breve',
  message = 'Esta área ainda não está disponível nesta fase da migração.',
}) => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <Telescope className="w-16 h-16 text-purple-300 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-purple-200 mb-2">{title}</h2>
        <p className="text-purple-200/70 mb-6">{message}</p>
        <Link to="/" className="btn-primary inline-flex items-center px-6 py-2">
          Voltar ao início
        </Link>
      </div>
    </div>
  );
};